import { createContext } from 'react'

// ID of the vendor a product list is restricted to by its route.
export const VendorFilterContext = createContext<string | undefined>(undefined)
